import React from 'react';
import { CurrencyInput, Field } from 'ui';
import {
  getCustomShippingPrice,
  ownLabelShippingPrice,
} from '~/store/listFlow/slices/shipping';
import { getListFlowFieldErrorMap } from '~/store/listFlow/ui';
import { useAppDispatch, useAppSelector } from '~/store/store';

interface Props {}

const ListFlowShippingCustomLabel: React.FC<Props> = () => {
  const dispatch = useAppDispatch();
  const customShippingPrice = useAppSelector(getCustomShippingPrice);
  const errors = useAppSelector(getListFlowFieldErrorMap);

  return (
    <div className="mt-6">
      <div className="grid grid-cols-1 gap-x-4 md:grid-cols-2">
        <Field
          name="us-shipping"
          label="US Shipping Price"
          error={errors?.fixed_cost_shipping_price_us}
        >
          <CurrencyInput
            onChange={value =>
              dispatch(
                ownLabelShippingPrice({
                  amount: value,
                  country: 'US',
                }),
              )
            }
            value={customShippingPrice.us}
          />
        </Field>

        <Field
          name="ca-shipping"
          label="CA Shipping Price"
          error={errors?.fixed_cost_shipping_price_ca}
        >
          <CurrencyInput
            onChange={value =>
              dispatch(
                ownLabelShippingPrice({
                  amount: value,
                  country: 'CA',
                }),
              )
            }
            value={customShippingPrice.ca}
          />
        </Field>
      </div>
    </div>
  );
};

export default ListFlowShippingCustomLabel;
